var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('DeviceLayout',{attrs:{"preview-data":{ name: _vm.previewNameLang, type: 'SensorCO2' },"is-preview":true,"device-icon":"co2"},scopedSlots:_vm._u([{key:"basic-controls",fn:function(){return [_c('div',{staticClass:"d-flex sensor-co2"},[_c('div',[_vm._v("4.981,47 ppm")])])]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }